import { render, staticRenderFns } from "./InformationCreateOrEdit.vue?vue&type=template&id=63b72f96&scoped=true&"
import script from "./InformationCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./InformationCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b72f96",
  null
  
)

export default component.exports